import React from 'react';
import StatusWithDraft from '../../../../model/StatusWithDraft';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import itemIdValue from '../../../itemIdValue';
import useLabel from '../../utils/Translations/useLabel';
import MultiselectFilter from './MultiselectFilter';
const StatusWithDraftMultiSelector = ({ title, ...props }) => {
    const { options } = useEnumerableModel(StatusWithDraft);
    const _title = useLabel('Status', title);
    return (<MultiselectFilter itemId={itemIdValue} options={options} title={_title} {...props}/>);
};
export default StatusWithDraftMultiSelector;
